/**
 * @name haveSameItems
 *
 * @description Returns true if all values from both arrays are also present in the other array
 *
 * @example
 * import { haveSameItems } from '@workbench/core';
 *
 * const item1 = 'Lorem';
 * const item2 = 'Ipsum';
 * const item3 = 'Dolor';
 *
 * const myArray1 = [item1, item2];
 * const myArray2 = [item3, item2, item1];
 *
 * haveSameItems(myArray1, myArray2); // false
 *
 * myArray1.push(item3);
 *
 * haveSameItems(myArray1, myArray2); // true
 */
export const haveSameItems = (arr1: Array<any> = [], arr2: Array<any> = []): boolean => {
  return arr1.every((i) => arr2.includes(i)) && arr2.every((i) => arr1.includes(i));
};
